import Bar from "./Bar";

// Mirrors the Whiteboard ListingCard box for box, so the list doesn't reflow
// when data lands. Real row for reference (AgentWhiteboard.js):
//   80px thumbnail | price text-lg mb-1 / address text-sm mb-2 / 3 specs
//   | status column (24px icon + two text-xs lines) | heart pinned top-right
const Row = () => (
  <div className="relative flex items-start border-b border-gray-200 px-4 py-4">
    {/* favourite heart, pinned exactly where the real one sits */}
    <div className="absolute right-4 top-2">
      <Bar w={18} h={18} r={9} />
    </div>

    <Bar w={80} h={80} r={8} className="shrink-0" />

    <div className="flex-1 px-4">
      {/* price — text-lg has a 28px line box */}
      <div className="mb-1 flex h-7 items-center">
        <Bar w={96} h={16} />
      </div>

      {/* address — text-sm, 20px line box */}
      <div className="mb-2 flex h-5 items-center">
        <Bar w="62%" h={12} />
      </div>

      {/* beds / baths / sqft */}
      <div className="flex h-5 items-center gap-4">
        <Bar w={38} h={12} />
        <Bar w={38} h={12} />
        <Bar w={62} h={12} />
      </div>
    </div>

    {/* status block: icon, "LIVE on MLS", day count — sits under the heart */}
    <div className="flex flex-col items-center justify-center gap-1 pt-6">
      <Bar w={24} h={24} r={12} />
      <Bar w={70} h={11} />
      <Bar w={46} h={10} />
    </div>
  </div>
);

const ListSkeleton = ({ rows = 5 }) => (
  <div>
    {Array.from({ length: rows }, (_, i) => (
      <Row key={i} />
    ))}
  </div>
);

export default ListSkeleton;
